<template>
  <div id="app">
    <viewer></viewer>
  </div>
</template>

<script>
// OGP タグをサーバサイドで書き出すためにAppを個別に作成
import Viewer from '@/pages/viewer/index.vue'

export default {
  name: 'app',
  components: {
    Viewer
  }
}
</script>

<style src="./app.css">
</style>
